<template>
  <div class="flex items-center gap-3">
    <div v-if="props.icon && props.icon.src" class="shrink-0">
      <TsImage
          :src="props.icon.src"
          :alt="props.icon.alt"
          class="min-w-max"
          :height="props.icon.size"
          :width="props.icon.size"
          loading="lazy"
      />
    </div>
    <TsTypography
        v-if="props.text"
        :text="props.text"
        :to="props.to"
        :variant="props.variant"
        :as="props.as"
        :append-class="props.appendClass"
        :weight="props.weight"
        :size="props.size"
        :align="props.align"
        :remove-margin="props.removeMargin"
    />
  </div>
</template>

<script setup lang="ts">
// Variant
const Variants = ["h1", "h2", "h3", "h4", "h5", "h6", "ul", "ol", "li", "md", "base", "sm", "xs", "xxs", "NuxtLink"] as const;

// Font Weights
const Weights = ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"] as const;

type Props = {
  icon?: {
    src?: string;
    size?: number;
    alt?:string;
  };
  to?: string;
  variant?: (typeof Variants)[number];
  as?: string;
  appendClass?: string;
  tsTitle?: boolean;
  text?: string;
  weight?: (typeof Weights)[number];
  size?: "md" | "base" | "sm" | "xs" | "xxs";
  align?: 'left' | 'center' | 'right' | 'justify';
  removeMargin?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  icon: () => ({
    size: 32
  })
})
</script>